import { useNavigate } from "react-router-dom"


export default function NotFound() {
    const navigate = useNavigate();
    return (
        <div className="background-container">
            <div className="container">
                <img src={process.env.PUBLIC_URL + '/icon512.png'} alt='Logo' width={300} height={42}></img>
                <h2>Essa página não existe</h2>
                <button className="btn-init" onClick={() => navigate('/')}>Ok!</button>
            </div>
        </div>
    )
}